module.exports = __webpack_public_path__ + "img/welcome.57135378.png";